module.exports = __webpack_public_path__ + "static/media/haven_map.e7ac5c6d.jpg";